<script setup>
defineProps({
  layoutName: {
    type: String,
    default: 'data',
  },
})
</script>

<template>
  <section class="client-layout client-layout--data" :data-layout="layoutName">
    <slot />
  </section>
</template>
